export class Vat {
  id: number;
  invoiceLineDiscriminator: string;
  code: string;
  description: string;
  percentage: number;
  active: boolean;
  startDate: Date;
  endDate: Date;
  export: boolean;
  bpm: boolean;
  marge: boolean;
  purchaseLedger: number;
  salesLedger: number;
}
